"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteModal = void 0;
var react_1 = __importStar(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var invite_modal_styles_1 = require("./invite_modal.styles");
var loading_button_1 = require("../LoadingButton/loading_button");
var InviteModal = function (props) {
    var children = props.children, cancelLabel = props.cancelLabel, inviteLabel = props.inviteLabel, loadingLabel = props.loadingLabel, sendLabel = props.sendLabel, isLoading = props.isLoading, isSuccess = props.isSuccess, disableSend = props.disableSend, secondary = props.secondary, onSetData = props.onSetData, onOpen = props.onOpen, header = props.header, onClose = props.onClose, pageDirection = props.pageDirection;
    var _a = (0, react_1.useState)(false), isModalOpen = _a[0], setIsModalOpen = _a[1];
    (0, react_1.useEffect)(function () {
        isSuccess && setIsModalOpen(false);
    }, [isSuccess]);
    var buttonRef = (0, react_1.useRef)(null);
    var InviteModalFooter = (react_1.default.createElement("div", null,
        react_1.default.createElement(invite_modal_styles_1.CancelButton, { onClick: function () {
                setIsModalOpen(false);
                if (onClose) {
                    onClose();
                }
            } }, cancelLabel),
        react_1.default.createElement(loading_button_1.LoadingButton, { onClickSend: onSetData, withMargin: true, isLoading: isLoading, isDisabled: disableSend, loadingLabel: loadingLabel, sendLabel: sendLabel })));
    var modalProps = {
        isOpen: isModalOpen,
        header: header,
        footer: InviteModalFooter,
        dir: pageDirection,
        onClose: function () {
            setIsModalOpen(false);
            if (onClose) {
                onClose();
            }
        },
        toggleEl: buttonRef.current,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storm_ui_1.Modal, __assign({}, modalProps), children),
        react_1.default.createElement(storm_ui_1.Button, { primary: !secondary, onClick: function () {
                if (onOpen) {
                    onOpen();
                }
                setIsModalOpen(true);
            }, buttonRef: function () { return buttonRef; }, disabled: isLoading }, inviteLabel)));
};
exports.InviteModal = InviteModal;
